import Env from '../base/env.js';
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { ScrollSmoother } from "../vendor/gsap-bonus-umd/ScrollSmoother";
import { ScrollToPlugin } from '../vendor/gsap-bonus-umd/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger,ScrollSmoother,ScrollToPlugin);

export default class Smoothie
{
  constructor()
  {
    this.DOM = {}
    // this.DOM.wrapper = document.querySelector('.jsSmoothWrapper')
    // this.DOM.content = document.querySelector('.jsSmoothContent')
    //
     //? Vars
     this.CAN_SMOOTH = Env.mobileCSS
     this.VARS = {
      smooth:{
        inertia:.7,
        progress:0,
        scrolltop:0
      }
    }
  }

  setup()
  {
    if(this.CAN_SMOOTH == false) {
      const withEffects = (Env.mobileCSS)?false:true;
      this.ENABLED = true
      this.DOM.wrapper = document.querySelector('.jsSmoothWrapper')
      this.DOM.content = document.querySelector('.jsSmoothContent')
      Env.smoothInstance = ScrollSmoother.create({
        wrapper:this.DOM.wrapper,
        content:this.DOM.content,
        smooth: this.VARS.smooth.inertia,
        effects: withEffects,
        smoothTouch: false,
        ease:'quint.out'
      });
    }

  }

  kill()
  {
    if(typeof Env.smoothInstance != 'undefined') {
      // setTimeout(() => {
        console.log('smoother kil');
        // Env.smoothInstance.scrollTrigger.kill(false)
        Env.smoothInstance.kill()
      // }, 100);
    }
  }

  update()
  {
    if(typeof Env.smoothInstance != 'undefined') {
      setTimeout(() => {
        console.log('smoother refresh');
        Env.smoothInstance.scrollTrigger.refresh()
      }, 100);
    }
  }

  reset()
  {
    if(typeof Env.smoothInstance != 'undefined') {
      console.log('smoother reset');
      setTimeout(() => {
        this.kill()

      }, 100);
      setTimeout(() => {
        this.setup()
      }, 200);
    }
  }
}
